import PropTypes from 'prop-types'
import React from 'react'
import Modal from 'components/util/Modal'
import styles from './_onboardingModal.css'
import { connect } from 'react-redux'
import { Button } from 'components/util'
import { FormattedMessage } from 'react-intl'
import * as site from 'services/site/selectors'

const mapStateToProps = (state) => ({
  siteName: site.selectSiteName(state),
})

function OnboardingModal ({ siteName, ...props }) {
  return (
    <Modal {...props} shouldScroll={true}>
      <div className={styles.container}>
        <h2 className={styles.title}>
          <FormattedMessage
            id='auth.signup.onboarding_modal.title'
            defaultMessage='You already have an account'
          />
        </h2>
        <p className={styles.description}>
          <FormattedMessage
            id='auth.signup.onboarding_modal.description'
            defaultMessage='Your email is already registered with an Under Armour app. Your Under Armour account works for {siteName}. Would you like to login instead?'
            values={{ siteName }}
          />
        </p>
        <div className={styles.controls}>
          <Button
            type='secondary'
            className={styles.button}
            onClick={props.onRequestedClose}
          >
            <FormattedMessage
              id='auth.signup.onboarding_modal.cancel'
              defaultMessage='Cancel'
            />
          </Button>
          <Button
            type='success'
            className={styles.button}
            onClick={props.onContinue}
          >
            <FormattedMessage
              id='auth.signup.onboarding_modal.login'
              defaultMessage='Log in'
            />
          </Button>
        </div>
      </div>
    </Modal>
  )
}

OnboardingModal.propTypes = {
  siteName: PropTypes.string,
  onRequestedClose: PropTypes.func,
  onContinue: PropTypes.func,
}

export default connect(mapStateToProps)(OnboardingModal)

